// API_URL is read from VUE_APP_API_URL in .env.local, which is gitignored
// and never committed/built into shared bundles. To point this app at a
// different backend (your own local server, UAT, etc.), edit .env.local --
// do not change the value below, since that's what deploys everywhere else.
// Falls back to the UAT API when no local override is present.
export const API_URL = process.env.VUE_APP_API_URL || "https://uatscanapi.totalbiometrics.net/api/v1";
export default API_URL;

